"use client";

import { Check, Clock, Sparkles, X } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function () {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const traditionalItems = [{
    text: "Slow manual setup"
  }, {
    text: "High monthly costs"
  }, {
    text: "Manual server config"
  }, {
    text: "Limited protocols"
  }, {
    text: "Complex interface"
  }, {
    text: "Frequent downtime"
  }];
  const aiItems = [{
    text: "Instant activation"
  }, {
    text: "Budget-friendly"
  }, {
    text: "Smart auto-routing"
  }, {
    text: "All-protocol support"
  }, {
    text: "Intuitive dashboard"
  }, {
    text: "99.9% uptime guarantee"
  }];
  return <section data-section-id="114" id="vpnheadtoheadcomparison" className="relative overflow-hidden bg-background py-20 sm:py-28 text-foreground">
      {}
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 opacity-60">
        <div className="absolute left-1/2 top-1/2 h-[600px] w-[600px] -translate-x-1/2 -translate-y-1/2 rounded-lg blur-3xl" style={{
        background: "radial-gradient(circle, hsl(22 100% 50% / 0.15) 0%, transparent 70%)"
      }} />
      </div>

      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        {}
        <div ref={headerRef} className={`mx-auto max-w-3xl text-center transition-all duration-700 ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <Badge variant="outline" className="mb-6 border-border bg-muted px-3 py-1 text-xs font-mono tracking-widest text-muted-foreground">
            VPN COMPARISON
          </Badge>
          <h2 className="font-default text-4xl font-bold tracking-tight text-foreground sm:text-5xl lg:text-6xl">
            Why users choose{" "}
            <span className="text-primary">
              VPNGENIX
            </span>
          </h2>
          <p className="mt-6 text-base sm:text-lg text-muted-foreground leading-relaxed">
            Compare standard VPN services against the advanced, AI-driven security of VPNGENIX.
          </p>
        </div>

        {}
        <div className="relative mt-16 grid grid-cols-1 gap-8 md:grid-cols-2 md:gap-6 lg:gap-10">
          {}
          <div aria-hidden="true" className="pointer-events-none absolute left-1/2 top-0 hidden h-full -translate-x-1/2 md:flex md:flex-col md:items-center md:justify-center z-10">
            <div className="h-full w-px bg-gradient-to-b from-transparent via-border to-transparent" />
            <div className="absolute flex h-14 w-14 items-center justify-center rounded-lg border border-border bg-background font-mono text-sm font-bold text-foreground shadow-md">
              VS
            </div>
          </div>

          {}
          <div ref={leftRef} className={`relative transition-all duration-700 ${leftVisible ? "opacity-70 translate-x-0" : "opacity-0 -translate-x-6"}`}>
            <div className="relative rounded-lg border border-border bg-card p-8 shadow-sm">
              <div className="mb-6 flex items-center gap-3">
                <div className="flex h-10 w-10 items-center justify-center rounded-md border border-border bg-muted">
                  <Clock className="h-5 w-5 text-muted-foreground" />
                </div>
                <h3 className="font-default text-xl font-semibold text-foreground">
                  Standard VPNs
                </h3>
              </div>

              <ul className="space-y-4">
                {traditionalItems.map((item, i) => <li data-index={i} key={i} className="flex items-center gap-3">
                    <div className="flex h-6 w-6 shrink-0 items-center justify-center rounded-md border border-destructive/30 bg-destructive/10">
                      <X className="h-3.5 w-3.5 text-destructive" />
                    </div>
                    <span className="text-sm sm:text-base text-muted-foreground">
                      {item.text}
                    </span>
                  </li>)}
              </ul>
            </div>
          </div>

          {}
          <div ref={rightRef} className={`relative transition-all duration-700 md:scale-[1.03] ${rightVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-6"}`}>
            {}
            <div aria-hidden="true" className="absolute -inset-px rounded-lg opacity-90 blur-sm bg-primary" />

            <div className="relative rounded-lg border border-primary/20 bg-card p-8 shadow-lg">
              {}
              <div className="absolute -top-3 right-6">
                <Badge className="border-0 px-3 py-1 font-mono text-[10px] font-semibold tracking-widest text-primary-foreground shadow-md bg-primary">
                  TOP CHOICE
                </Badge>
              </div>

              <div className="mb-6 flex items-center gap-3">
                <div className="flex h-10 w-10 items-center justify-center rounded-md bg-primary shadow-md">
                  <Sparkles className="h-5 w-5 text-primary-foreground" />
                </div>
                <h3 className="font-default text-xl font-semibold text-foreground">
                  VPNGENIX
                </h3>
              </div>

              <ul className="space-y-4">
                {aiItems.map((item, i) => <li data-index={i} key={i} className="flex items-center gap-3">
                    <div className="flex h-6 w-6 shrink-0 items-center justify-center rounded-md bg-primary shadow">
                      <Check className="h-3.5 w-3.5 text-primary-foreground" strokeWidth={3} />
                    </div>
                    <span className="text-sm sm:text-base text-foreground">
                      {item.text}
                    </span>
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>;
}